export default __webpack_public_path__ + "static/media/15.3a961cb7.png";